export default __webpack_public_path__ + "static/media/AnimalPage2.20546ae0.txt";